"use client";

import { Languages } from "lucide-react";
import { useAppShell } from "@/components/providers/app-providers";

/** LTR/RTL toggle — switches the whole document direction and language for the Arabic parity check. */
export function DirectionToggle() {
  const { direction, setDirection } = useAppShell();
  const isRtl = direction === "rtl";

  return (
    <button
      type="button"
      onClick={() => setDirection(isRtl ? "ltr" : "rtl")}
      aria-pressed={isRtl}
      className="flex items-center gap-1.5 rounded-control border border-border-subtle bg-surface-primary px-3 py-2 text-xs font-bold text-text-secondary shadow-[var(--shadow-subtle)] hover:bg-surface-secondary"
    >
      <Languages aria-hidden="true" size={14} />
      {isRtl ? "العربية (RTL)" : "English (LTR)"}
    </button>
  );
}
